import { useFormikContext } from "formik";
import React, { FC } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { ListQuery } from "../../../models/ListQuery";
import { getDeviceImproxNames } from "../../../services/deviceImproxService";
import { appendFilter } from "../../../utilities/filters";
import PaginatedSearchableSelectField from "../../selection-field/paginated-searchable-select-field";
import Label from "../../label/label";

interface ManuallyMusteringFormProps {
    siteId: string;
}

const ManuallyMusteringForm: FC<ManuallyMusteringFormProps> = ({ siteId }) => {
    const { translate } = useLocale();
    const { values, setFieldValue } = useFormikContext<any>();
    
    const getText = (value) => {
        return value || value !== "" ? value : "-";
    }

    const getFilters  = () => {
        // On the given site find all mustering points
        return appendFilter(siteId, "Site", "site.id", appendFilter("1", "Mustering Point", "musteringPoint", []))
    }

    return <>
        <div className='flex flex-col pr-6 text-sm space-y-2'>
            <Label className='font-bold block w-32 overflow-hidden' style={{ textOverflow: "ellipsis" }} htmlFor="nameLabel">{translate.byKey(TranslationKeys.name)}</Label>
            <Label className='font-bold block w-32 overflow-hidden' style={{ textOverflow: "ellipsis" }} htmlFor="idNumberLabel">{translate.byKey(TranslationKeys.idNumber)}</Label>
            <Label className='font-bold block w-32 overflow-hidden' style={{ textOverflow: "ellipsis" }} htmlFor="departmentLabel">{translate.byKey(TranslationKeys.department)}</Label>
            <Label className='font-bold block w-32 overflow-hidden' style={{ textOverflow: "ellipsis" }} htmlFor="suffixLabel">{translate.byKey(TranslationKeys.suffix)}</Label>
            <Label className='font-bold block w-32 overflow-hidden' style={{ textOverflow: "ellipsis" }} htmlFor="profileLabel">{translate.byKey(TranslationKeys.category)}</Label>
            <Label className='font-bold block w-32 overflow-hidden' style={{ textOverflow: "ellipsis" }} htmlFor="musteringPointId" requireMarkerDirection="right" required>{translate.byKey(TranslationKeys.musteringPoint)}</Label>
        </div>
        <div className='flex flex-col text-sm space-y-2'>
            <Label htmlFor="displayNameValue" className="block w-64 overflow-hidden" style={{ textOverflow: "ellipsis" }}>{values.displayName}</Label>
            <Label htmlFor="idNumberValue" className="block w-64 overflow-hidden" style={{ textOverflow: "ellipsis" }}>{values.idNumber}</Label>
            <Label htmlFor="departmentValue" className="block w-64 overflow-hidden" style={{ textOverflow: "ellipsis" }}>{getText(values.department)}</Label>
            <Label htmlFor="suffixValue" className="block w-64 overflow-hidden" style={{ textOverflow: "ellipsis" }}>{getText(values.suffix)}</Label>
            <Label htmlFor="profileValue" className="block w-64 overflow-hidden" style={{ textOverflow: "ellipsis" }}>{values.profile}</Label>
            <PaginatedSearchableSelectField
                name={translate.byKey(TranslationKeys.device)}
                key={"musteringPointId"}
                accessor='musteringPointId'
                dataMethod={(listParameters?: ListQuery) => getDeviceImproxNames({ ...listParameters, filters: getFilters() })}
                searchAccessor={'devName'}
                required={true}
                onSelect={(value) => { setFieldValue('musteringPointId', value) }} />
        </div>
    </>
}

export default ManuallyMusteringForm;